import React from "react";
import { FormattedMessage } from "react-intl";

const CartProduct = ({productId, onCartDelete, isMobile}) => {
    return (
        <div className="cartItem">
          <span className='cartProductName'><FormattedMessage id={`${ productId }.name`} /></span>
          <span className="cartProductRemove">
            <button className="btn removeButton" onClick={() => onCartDelete(productId)}><i class="icon fa fa-trash-o"></i></button>
          </span>
        </div>
    );
}

export default CartProduct;